<app-dialog>
  <div class="scroll-wrapper" body>
    <app-full-loading
      *ngIf="tasksService.loading"
      [backdrop]="true"
    ></app-full-loading>

    <div class="tasks-list" (scroll)="scrollWindow($event)">
      <ng-container *ngIf="data.data.amount; else defaultList">
        <ng-container
          *ngFor="let item of tasksService.tasks.slice(0, data.data.amount)"
        >
<!--          <app-task-item-->
<!--            [data]="item"-->
<!--            [statuses]="tasksService.taskStatus"-->
<!--            [priority]="tasksService.taskPriority"-->
<!--            (changeStatusEvent)="data.data.changeTaskStatus($event)"-->
<!--            [changeStatusToPrev]="tasksService.changeTaskStatus$.asObservable()"-->
<!--            [actions]="actions"-->
<!--            (clickOnTaskName)="viewTaskDetail($event)"-->
<!--            (taskMenuAction)="data.data.taskMenuAction($event)"-->
<!--          ></app-task-item>-->
        </ng-container>
      </ng-container>
      <ng-template #defaultList>
<!--        <app-task-item-->
<!--          *ngFor="let item of tasksService.tasks"-->
<!--          [data]="item"-->
<!--          [statuses]="tasksService.taskStatus"-->
<!--          [priority]="tasksService.taskPriority"-->
<!--          (changeStatusEvent)="data.data.changeTaskStatus($event)"-->
<!--          [changeStatusToPrev]="tasksService.changeTaskStatus$.asObservable()"-->
<!--          [actions]="actions"-->
<!--          (clickOnTaskName)="viewTaskDetail($event)"-->
<!--          (taskMenuAction)="data.data.taskMenuAction($event)"-->
<!--        ></app-task-item>-->
      </ng-template>
    </div>
  </div>
</app-dialog>
